import React from 'react';

const DgServiceMappingSection = () => {
  // Service mapping data
const serviceMappings = [
  {
    id: 1,
    digitalOceanService: 'Droplets',
    hetznerService: 'Hetzner Cloud Servers',
    description: 'Virtual servers for hosting applications, websites, and workloads',
    savings: '~70%',
    icon: 'server'
  },
  {
    id: 2,
    digitalOceanService: 'Block Storage Volumes',
    hetznerService: 'Volumes',
    description: 'High-performance block storage for virtual machines',
    savings: '~75%',
    icon: 'storage'
  },
  {
    id: 3,
    digitalOceanService: 'Spaces',
    hetznerService: 'Object Storage',
    description: 'Scalable object storage for backups, media files, and application assets',
    savings: '~80%',
    icon: 'cloud'
  },
  {
    id: 4,
    digitalOceanService: 'Managed Databases',
    hetznerService: 'Database Solutions',
    description: 'Managed and self-hosted MySQL, PostgreSQL, and MariaDB databases',
    savings: '~75%',
    icon: 'database'
  },
  {
    id: 5,
    digitalOceanService: 'DNS',
    hetznerService: 'Hetzner DNS',
    description: 'Reliable domain and DNS management services',
    savings: '~100%',
    icon: 'globe'
  },
  {
    id: 6,
    digitalOceanService: 'Monitoring',
    hetznerService: 'Grafana & Prometheus',
    description: 'Infrastructure monitoring, alerting, and performance analytics',
    savings: '~90%',
    icon: 'chart'
  },
  {
    id: 7,
    digitalOceanService: 'Kubernetes',
    hetznerService: 'Hetzner Kubernetes',
    description: 'Container orchestration and scalable application deployment',
    savings: '~70%',
    icon: 'cube'
  },
  {
    id: 8,
    digitalOceanService: 'VPC',
    hetznerService: 'Private Networks',
    description: 'Secure networking and private connectivity between resources',
    savings: '~100%',
    icon: 'lock'
  }
];

  // Icon components
const ServerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-10 h-10 text-gray-500 mb-4">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M9 3v2m6-2v2M9 19v2m6-2v2M3 9h2m-2 6h2m14-6h2m-2 6h2M8 8h8v8H8V8z" />
  </svg>
);

  const StorageIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-10 h-10 text-gray-500 mb-4">
      <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
    </svg>
  );

const CloudIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-10 h-10 text-gray-500 mb-4">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M12 16V8m0 0-3 3m3-3 3 3M6 16.5a4.5 4.5 0 01.5-9A5.25 5.25 0 0117 8.25h.75A3.75 3.75 0 0118 15.75H6z" />
  </svg>
);

  const DatabaseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-10 h-10 text-gray-500 mb-4">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M12 3c-4.418 0-8 1.343-8 3v12c0 1.657 3.582 3 8 3s8-1.343 8-3V6c0-1.657-3.582-3-8-3z" />
  </svg>
);

  const GlobeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-10 h-10 text-gray-500 mb-4">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
  </svg>
);

const ChartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-10 h-10 text-gray-500 mb-4">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M3 17l5-5 4 4 8-8" />
  </svg>
);

const CubeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-10 h-10 text-gray-500 mb-4">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" />
  </svg>
);

const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-10 h-10 text-gray-500 mb-4">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M12 3l7.5 3v6c0 5.25-3.75 8.25-7.5 9-3.75-.75-7.5-3.75-7.5-9V6L12 3z" />
  </svg>
);

  const getIcon = (iconType) => {
    switch (iconType) {
      case 'server':
        return <ServerIcon />;
      case 'storage':
        return <StorageIcon />;
      case 'cloud':
        return <CloudIcon />;
      case 'database':
        return <DatabaseIcon />;
      case 'globe':
        return <GlobeIcon />;
      case 'chart':
        return <ChartIcon />;
      case 'cube':
        return <CubeIcon />;
      case 'lock':
        return <LockIcon />;
      default:
        return <ServerIcon />;
    }
  };

  // Arrow Icon
  const ArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4 text-gray-400">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
    </svg>
  );

  return (
    <section id="mapping-section" className="py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">
            Migration Mapping
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-00 mt-2 mb-4 transition-all duration-1000 opacity-100 translate-y-0">
            DigitalOcean  Services to Hetzner Infrastructure
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto transition-all duration-1000 delay-200 opacity-100 translate-y-0">
            Explore equivalent infrastructure options for a smooth and efficient DigitalOcean  migration.
          </p>
        </div>
        
        {/* Service Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {serviceMappings.map((service) => (
            <div 
              key={service.id}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100 opacity-100 translate-y-0"
              style={{ transitionDelay: service.delay, transitionDuration: '1000ms' }}
            >
              {getIcon(service.icon)}
              
              <div className="flex items-center gap-2 mb-3">
                <span className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs font-bold">
                  {service.digitalOceanService}
                </span>
                <ArrowIcon />
                <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-bold">
                  {service.hetznerService}
                </span>
              </div>
              
              <p className="text-gray-700 text-sm mb-2">
                {service.description}
              </p>
              
              <p className="text-green-600 font-bold text-sm">
                Savings: {service.savings}
              </p>
            </div>
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default DgServiceMappingSection;